<template>
    <basic-container style="position: relative;width:100%;">
      <avue-crud :option="option"
                 :table-loading="loading"
                 :data="data"
                 :page.sync="page"
                 :permission="permissionList"
                 :before-open="beforeOpen"
                 v-model="form"
                 ref="crud"
                 @row-update="rowUpdate"
                 @row-save="rowSave"
                 @row-del="rowDel"
                 @search-change="searchChange"
                 @search-reset="searchReset"
                 @selection-change="selectionChange"
                 @current-change="currentChange"
                 @size-change="sizeChange"
                 @on-load="onLoad"
                 @refresh-change="onLoad"
      >
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/crmedical/energy/energymeterparam";
    import {mapGetters} from "vuex";

    export default {
      data: function () {
        return {
          form: {},
          query: {},
          loading: true,
          page: {
            pageSize: 10,
            currentPage: 1,
            total: 0
          },
          selectionList: [],
          option: {
            height: 'auto',
            calcHeight: 50,
            tip: false,
            border: true,
            index: true,
            indexLabel: "序号",
            viewBtn: true,
            selection: false,
            delBtn: false,
            searchMenuSpan: 6,
            columnBtn: false,
            refreshBtn: false,
            emptyBtnText:'重置',
            column: [
              {
                label: "主键",
                prop: "id",
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: true,
              },
              {
                label: "参数编号",
                prop: "code",
                maxlength: 32,
                showWordLimit: true,
                overHidden: true,
                search: true,
                rules: [{
                  required: true,
                  message: "请输入参数编号",
                  trigger: "blur"
                }]
              },
              {
                label: "参数名称",
                prop: "name",
                maxlength: 32,
                showWordLimit: true,
                overHidden: true,
                search: true,
                rules: [{
                  required: true,
                  message: "请输入参数名称",
                  trigger: "blur"
                }]
              },
              {
                label: "仪表类型",
                prop: "meterType",
                type: 'select',
                dataType: 'number',
                dicUrl: 'api/blade-system/dict/dictionary?code=meter_type',
                props: { label: 'dictValue', value: 'dictKey' },
                rules: [{
                  required: true,
                  message: "请选择仪表类型",
                  trigger: "blur"
                }]
              },
              {
                label: "计量单位",
                prop: "measuringUnit",
                type: 'select',
                dataType: 'number',
                dicUrl: 'api/blade-system/dict/dictionary?code=energy_measuring_unit',
                props: { label: 'dictValue', value: 'dictKey' },
                rules: [{
                  required: true,
                  message: "请选择计量单位",
                  trigger: "blur"
                }]
              },
              {
                label: "标识",
                prop: "identifyContent",
                maxlength: 500,
                showWordLimit: true,
                overHidden: true,
              },
              {
                label: "说明",
                prop: "description",
                type: 'textarea',
                maxlength: 200,
                showWordLimit: true,
                overHidden: true,
                span: 24,
                row: 2,
              },
            ]
          },
          data: []
        };
      },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.energymeterparam_add, false),
                    viewBtn: this.vaildData(this.permission.energymeterparam_view, false),
                    delBtn: this.vaildData(this.permission.energymeterparam_delete, false),
                    editBtn: this.vaildData(this.permission.energymeterparam_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, loading, done) {
                add(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
                update(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
          searchChange(params, done) {
            this.query = params;
            this.page.currentPage = 1;
            this.onLoad();
            done();
          },
          selectionChange(list) {
            this.selectionList = list;
          },
          selectionClear() {
            this.selectionList = [];
            this.$refs.crud.toggleSelection();
          },
          currentChange(currentPage) {
            this.page.currentPage = currentPage;
          },
          sizeChange(pageSize) {
            this.page.pageSize = pageSize;
          },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>

</style>
